export default __webpack_public_path__ + "static/StreamCorridorProtectionOrdinances-23c84098149f6d847fe619541ec8978f.jpg";